export default __webpack_public_path__ + "static/media/lysningen-property-15.1df66fb3.jpg";